import React from "react";
import { makeStyles } from "@mui/styles";
import { Button, Card } from "@mui/material";
import LoadingBar from "../LoadingBar/LoadingBar";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
    justifyContent: "space-between",
    width: "30%",
    height: "20%",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
      paddingLeft: "10px",
    },
    fontSize: "24px",
    paddingTop: "5%",
    paddingLeft: "15px",
  },
  buttonSection: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "50%",
    width: "100%",
  },
  button: {
    [theme.breakpoints.down("md")]: {
      minWidth: "unset",
      minHeight: "unset",
      width: "30%",
    },
    minWidth: "200px",
    minHeight: "50px",
  },
}));

const confirm = (func, closeModal) => {
  func();
  closeModal();
};

export default function ConfirmationModal({
  question,
  func,
  closeModal,
  processing,
}) {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <LoadingBar loading={processing} />
      <span className={classes.title}>{question}</span>
      <div className={classes.buttonSection}>
        <Button
          className={classes.button}
          style={{ backgroundColor: "#E45E42" }}
          type=""
          variant="contained"
          color="primary"
          disabled={processing}
          onClick={() => confirm(func, closeModal)}
        >
          Yes
        </Button>
        <Button
          className={classes.button}
          style={{ backgroundColor: "#82B288" }}
          type=""
          variant="contained"
          color="primary"
          disabled={processing}
          onClick={() => closeModal()}
        >
          No
        </Button>
      </div>
    </Card>
  );
}
